// ── SVG ICON SYSTEM (replaces emojis for premium look) ──
export const SVG_ICONS = {
  gold: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3h12l4 6-10 13L2 9z"/><path d="M11 3l3 6H2"/><path d="M13 3l-3 6h12"/><path d="M2 9l10 13L22 9"/></svg>`,
  silver: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v12M8 10l4-4 4 4M8 14l4 4 4-4"/></svg>`,
  crudeoil: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18"/><path d="M6 12h12"/><path d="M6 7h12"/><path d="M6 17h12"/><path d="M4 22h16"/></svg>`,
  brentcrude: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2z"/><path d="M12 6v6l4 2"/><path d="M6 12h2M16 12h2M12 6v2M12 16v2"/></svg>`,
  naturalgas: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 12c-2-2.67-4-4-4-6a4 4 0 0 1 8 0c0 2-2 3.33-4 6z"/><path d="M12 21a8 8 0 0 0 8-8c0-4-4-6-8-10-4 4-8 6-8 10a8 8 0 0 0 8 8z"/></svg>`,
  copper: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3"/><path d="M9 3v18"/><path d="M15 3v18"/><path d="M3 9h18"/><path d="M3 15h18"/></svg>`,
  aluminium: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h16"/><path d="M4 20V10l8-8 8 8v10"/><path d="M9 20v-6h6v6"/></svg>`,
  zinc: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><path d="M12 22V12"/><path d="M3.3 7L12 12l8.7-5"/></svg>`,
  nickel: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v8"/><path d="M8 12h8"/></svg>`,
  lead: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="2" width="12" height="20" rx="2"/><path d="M6 18h12"/><path d="M6 14h12"/><path d="M10 6h4"/></svg>`,
  platinum: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>`,
  chart: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>`,
  sun: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>`,
  moon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>`,
  refresh: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>`,
};
  
// ── COMMODITY CONFIGURATION ──
export const COMMODITIES = {
  gold: {
    name: 'Gold',
    symbol: 'XAU/USD',
    icon: SVG_ICONS.gold,
    category: 'precious',
    categoryLabel: 'Precious Metal',
    accentColor: 'hsl(45, 93%, 47%)',
    accentBg: 'hsl(45, 93%, 47%)',
    yahooSymbol: 'GC=F',
    intlUnit: 'Troy Oz',
    indiaUnit: 'g',
    conversionDivisor: 31.1035,
    dutyRate: 0.06,
    dutyLabel: 'BCD 5% + AIDC 1% = 6%',
    showPurity: true,
    show10g: true,
    showKg: true,
    miniContracts: [
      { name: 'Gold Mini', lot: '1g', multiplier: 1 },
      { name: 'Gold Guinea', lot: '8g', multiplier: 8 },
      { name: 'Gold Petal', lot: '0.5g', multiplier: 0.5 },
    ],
  },
  silver: {
    name: 'Silver',
    symbol: 'XAG/USD',
    icon: SVG_ICONS.silver,
    category: 'precious',
    categoryLabel: 'Precious Metal',
    accentColor: 'hsl(210, 10%, 62%)',
    accentBg: 'hsl(210, 10%, 62%)',
    yahooSymbol: 'SI=F',
    intlUnit: 'Troy Oz',
    indiaUnit: 'g',
    conversionDivisor: 31.1035,
    dutyRate: 0.06,
    dutyLabel: 'BCD 5% + AIDC 1% = 6%',
    showPurity: true,
    show10g: true,
    showKg: true,
    purityLabels: [
      { label: '999 Fine', ratio: 1.0 },
      { label: '925 Sterling', ratio: 0.925 },
      { label: '900 Coin', ratio: 0.90 },
    ],
    miniContracts: [
      { name: 'Silver (1 kg)', lot: '1kg', multiplier: 1000 },
      { name: 'Silver Mini', lot: '5kg', multiplier: 5000 },
      { name: 'Silver Micro', lot: '1kg', multiplier: 1000 },
    ],
  },
  crudeoil: {
    name: 'Crude Oil (WTI)',
    symbol: 'WTI',
    icon: SVG_ICONS.crudeoil,
    category: 'energy',
    categoryLabel: 'Energy',
    accentColor: 'hsl(20, 80%, 45%)',
    accentBg: 'hsl(20, 80%, 45%)',
    yahooSymbol: 'CL=F',
    intlUnit: 'Barrel',
    indiaUnit: 'barrel',
    conversionDivisor: 1,
    dutyRate: 0.05,
    dutyLabel: 'Effective duty ~5%',
    showPurity: false,
    show10g: false,
  },
  brentcrude: {
    name: 'Brent Crude',
    symbol: 'BRENT',
    icon: SVG_ICONS.brentcrude,
    category: 'energy',
    categoryLabel: 'Energy',
    accentColor: 'hsl(30, 85%, 42%)',
    accentBg: 'hsl(30, 85%, 42%)',
    yahooSymbol: 'BZ=F',
    intlUnit: 'Barrel',
    indiaUnit: 'barrel',
    conversionDivisor: 1,
    dutyRate: 0.05,
    dutyLabel: 'Effective duty ~5%',
    showPurity: false,
    show10g: false,
  },
  naturalgas: {
    name: 'Natural Gas',
    symbol: 'NG',
    icon: SVG_ICONS.naturalgas,
    category: 'energy',
    categoryLabel: 'Energy',
    accentColor: 'hsl(200, 70%, 50%)',
    accentBg: 'hsl(200, 70%, 50%)',
    yahooSymbol: 'NG=F',
    intlUnit: 'MMBtu',
    indiaUnit: 'MMBtu',
    conversionDivisor: 1,
    dutyRate: 0.025,
    dutyLabel: 'BCD 2.5%',
    showPurity: false,
    show10g: false,
  },
  copper: {
    name: 'Copper',
    symbol: 'HG',
    icon: SVG_ICONS.copper,
    category: 'industrial',
    categoryLabel: 'Industrial Metal',
    accentColor: 'hsl(15, 75%, 50%)',
    accentBg: 'hsl(15, 75%, 50%)',
    yahooSymbol: 'HG=F',
    intlUnit: 'Pound',
    indiaUnit: 'kg',
    conversionDivisor: 0.453592,
    conversionMode: 'lbToKg',
    dutyRate: 0.025,
    dutyLabel: 'BCD 2.5%',
    showPurity: false,
    show10g: false,
  },
  aluminium: {
    name: 'Aluminium',
    symbol: 'ALI',
    icon: SVG_ICONS.aluminium,
    category: 'industrial',
    categoryLabel: 'Industrial Metal',
    accentColor: 'hsl(200, 15%, 55%)',
    accentBg: 'hsl(200, 15%, 55%)',
    yahooSymbol: 'ALI=F',
    intlUnit: 'Metric Ton',
    indiaUnit: 'kg',
    conversionDivisor: 1000,
    dutyRate: 0.075,
    dutyLabel: 'BCD 7.5%',
    showPurity: false,
    show10g: false,
  },
  zinc: {
    name: 'Zinc',
    symbol: 'ZNC',
    icon: SVG_ICONS.zinc,
    category: 'industrial',
    categoryLabel: 'Industrial Metal',
    accentColor: 'hsl(180, 25%, 50%)',
    accentBg: 'hsl(180, 25%, 50%)',
    yahooSymbol: null,
    lmeOnly: true,
    intlUnit: 'Metric Ton',
    indiaUnit: 'kg',
    conversionDivisor: 1000,
    dutyRate: 0.05,
    dutyLabel: 'BCD 5%',
    showPurity: false,
    show10g: false,
  },
  nickel: {
    name: 'Nickel',
    symbol: 'NI',
    icon: SVG_ICONS.nickel,
    category: 'industrial',
    categoryLabel: 'Industrial Metal',
    accentColor: 'hsl(150, 20%, 50%)',
    accentBg: 'hsl(150, 20%, 50%)',
    yahooSymbol: null,
    lmeOnly: true,
    intlUnit: 'Metric Ton',
    indiaUnit: 'kg',
    conversionDivisor: 1000,
    dutyRate: 0.0,
    dutyLabel: 'Duty Free (0%)',
    showPurity: false,
    show10g: false,
  },
  lead: {
    name: 'Lead',
    symbol: 'PB',
    icon: SVG_ICONS.lead,
    category: 'industrial',
    categoryLabel: 'Industrial Metal',
    accentColor: 'hsl(220, 15%, 45%)',
    accentBg: 'hsl(220, 15%, 45%)',
    yahooSymbol: null,
    lmeOnly: true,
    intlUnit: 'Metric Ton',
    indiaUnit: 'kg',
    conversionDivisor: 1000,
    dutyRate: 0.05,
    dutyLabel: 'BCD 5%',
    showPurity: false,
    show10g: false,
  },
  platinum: {
    name: 'Platinum',
    symbol: 'XPT/USD',
    icon: SVG_ICONS.platinum,
    category: 'precious',
    categoryLabel: 'Precious Metal',
    accentColor: 'hsl(200, 8%, 65%)',
    accentBg: 'hsl(200, 8%, 65%)',
    yahooSymbol: 'PL=F',
    intlUnit: 'Troy Oz',
    indiaUnit: 'g',
    conversionDivisor: 31.1035,
    dutyRate: 0.1539,
    dutyLabel: 'BCD 12.5% + SWS',
    showPurity: false,
    show10g: true,
  },
};
  
// ── YAHOO FINANCE PROXY (multiple CORS proxies for reliability) ──
// Each entry is a function: (rawUrl) => proxyUrl
export const CORS_PROXIES = [
  u => `https://api.allorigins.win/raw?url=${encodeURIComponent(u)}`,
  u => `https://api.codetabs.com/v1/proxy?quest=${encodeURIComponent(u)}`,
  u => `https://thingproxy.freeboard.io/fetch/${u}`,
  u => `https://api.scraperapi.com/?url=${encodeURIComponent(u)}`,
];
